import _ from 'lodash';

const processStrategy = (command) => {
  const relations = {};
  const omit = [];
  return { ..._.omit(command, omit), ..._.pickBy(relations, _.identity) };
};

export default {
  key: 'command',
  definition: {},
  processStrategy,
};
